import { createBrowserRouter, RouterProvider } from "react-router";
import useRoutes from "components/general/Router";
import * as Sentry from "@sentry/react";

export default function App() {
  const routes = useRoutes();
  const router = createBrowserRouter(routes);
  return (
    <Sentry.ErrorBoundary fallback={<p>حدث خطأ غير متوقع.</p>}>
      <RouterProvider router={router} />
    </Sentry.ErrorBoundary>
  );
}
